// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#curve-editor {
  background: #333333;
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-rows: 40px calc(100% - 85px) 45px;
  grid-template-columns: 10px 210px 10px 1fr 10px;
}
#curve-editor #top-bar {
  background: #333333;
  grid-row: 1;
  grid-column: 1/6;
  width: 100%;
  height: 100%;
}
#curve-editor #bottom-bar {
  background: #333333;
  grid-row: 3;
  grid-column: 1/6;
  width: 100%;
  height: 100%;
}
#curve-editor #canvas-zone {
  grid-row: 2;
  grid-column: 4;
  width: 100%;
  height: 100%;
  background: #333333;
}
#curve-editor #sidebar {
  grid-row: 2;
  grid-column: 2;
  width: 100%;
  height: 100%;
  background: #111111;
}
#curve-editor .action-button:hover {
  background: #666666;
  color: white;
  cursor: pointer;
}
#curve-editor .action-button.active {
  background: #111111;
}
#curve-editor .action-button:active {
  transform-origin: 50% 50%;
  transform: scale(0.96);
}
#curve-editor .push-button {
  cursor: pointer;
}
#curve-editor .push-button.active {
  background: #666666;
}
#curve-editor .text-input {
  color: white;
  background: #000000;
  font-family: "acumin-pro-condensed";
  font-size: 11pt;
  border: 0;
  margin: 3px 1px;
  text-align: end;
  padding-right: 4px;
}
#curve-editor .text-input:focus {
  outline: none;
}
#curve-editor .text-input:disabled {
  background: #444444;
  border: #555555 solid 1px;
}`, "",{"version":3,"sources":["webpack://./../../../dev/inspector/dist/components/actionTabs/tabs/propertyGrids/animations/curveEditor/scss/curveEditor.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,+CAAA;EACA,+CAAA;AACJ;AACI;EACI,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;AACR;AAEI;EACI,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;AAAR;AAGI;EACI,WAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AADR;AAII;EACI,WAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AAFR;AAMQ;EACI,mBAAA;EACA,YAAA;EACA,eAAA;AAJZ;AAOQ;EACI,mBAAA;AALZ;AAQQ;EACI,yBAAA;EACA,sBAAA;AANZ;AAUI;EACI,eAAA;AARR;AASQ;EACI,mBAAA;AAPZ;AAWI;EACI,YAAA;EACA,mBAAA;EACA,mCAAA;EACA,eAAA;EACA,SAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;AATR;AAWQ;EACI,aAAA;AATZ;AAYQ;EACI,mBAAA;EACA,yBAAA;AAVZ","sourcesContent":["#curve-editor {\r\n    background: #333333;\r\n    width: 100%;\r\n    height: 100%;\r\n    display: grid;\r\n    grid-template-rows: 40px calc(100% - 85px) 45px;\r\n    grid-template-columns: 10px 210px 10px 1fr 10px;\r\n\r\n    #top-bar {\r\n        background: #333333;\r\n        grid-row: 1;\r\n        grid-column: 1 / 6;\r\n        width: 100%;\r\n        height: 100%;\r\n    }\r\n\r\n    #bottom-bar {\r\n        background: #333333;\r\n        grid-row: 3;\r\n        grid-column: 1 / 6;\r\n        width: 100%;\r\n        height: 100%;\r\n    }\r\n\r\n    #canvas-zone {\r\n        grid-row: 2;\r\n        grid-column: 4;\r\n        width: 100%;\r\n        height: 100%;\r\n        background: #333333;\r\n    }\r\n\r\n    #sidebar {\r\n        grid-row: 2;\r\n        grid-column: 2;\r\n        width: 100%;\r\n        height: 100%;\r\n        background: #111111;\r\n    }\r\n\r\n    .action-button {\r\n        &:hover {\r\n            background: #666666;\r\n            color: white;\r\n            cursor: pointer;\r\n        }\r\n\r\n        &.active {\r\n            background: #111111;\r\n        }\r\n\r\n        &:active {\r\n            transform-origin: 50% 50%;\r\n            transform: scale(0.96);\r\n        }\r\n    }\r\n\r\n    .push-button {\r\n        cursor: pointer;\r\n        &.active {\r\n            background: #666666;\r\n        }\r\n    }\r\n\r\n    .text-input {\r\n        color: white;\r\n        background: #000000;\r\n        font-family: \"acumin-pro-condensed\";\r\n        font-size: 11pt;\r\n        border: 0;\r\n        margin: 3px 1px;\r\n        text-align: end;\r\n        padding-right: 4px;\r\n\r\n        &:focus {\r\n            outline: none;\r\n        }\r\n\r\n        &:disabled {\r\n            background: #444444;\r\n            border: #555555 solid 1px;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
